<template>
    <section class="peditor" @click="$emit('close')">
        <div class="peditor-container" @click.stop>
            <div class="modal-close" @click="$emit('close')">
                <img src="@/assets/images/icons/icon_close.svg" />
            </div>
            <h2>Редактирование профиля</h2>

            <div class="filters-body">
                <div class="filters-item">
                    <!-- <div class="button" :class="{active: hasActive('country')}">Страна</div> -->
                    <multiselect v-model="country" :showLabels="false" :options="countries" :label="'name'" placeholder="Страна" @input="setFilter(country, 'country')"></multiselect>
                </div>
                <div class="filters-item">
                    <multiselect v-model="state" :showLabels="false" :options="states" :label="'name'" placeholder="Город" @input="setFilter($event, 'state')"></multiselect>
                </div>
                <div class="filters-item">
                    <multiselect v-model="sex" :showLabels="false" :options="sexes" placeholder="Пол" @input="setSex(sex, 'sex')"></multiselect>
                </div>
                <div class="filters-item" v-if="sex === 'Ввести свой'">
                    <input class="input" v-model="other_sex" placeholder="Введите свой пол" @input="setSex(sex, 'sex')"/>
                </div>
            </div>
            <div class="peditor-footer" v-if="other_sex && other_sex.length > 0">
                <div class="button active" @click="setSex(other_sex, 'sex') ">Сохранить</div>  
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
    name: 'ProfileEditor',
    data: () => {
        return {
            countries: [],
            country: null,
            state: null,
            states: [],
            sexes: ['Мужчина', 'Женщина', 'Ввести свой'],
            sex: null,
            other_sex: null
        }
    },
    components: {
        Multiselect
    },
    computed: {
        ...mapState({
            user: state => state.profile.user
        }),
         getUser () {
            return this.$store.getters.getAuthUser
        }
    },
    methods: {
        getUserCountry() {
            this.country = this.countries.find(country => country.name === this.user.profile.country_code) || {name: this.user.profile.country}
        },
        getUserState() {
            this.state = this.states.find(state => state.name === this.user.profile.state) || {name: this.user.profile.state}
        },
        async setSex (filter, group) {
            if (filter !== 'Ввести свой') {
            await this.$store.dispatch('editUser', {options: {type: group, value: filter }, user: this.getUser.id})
                .then(() =>{
                    this.user.profile.sex = filter
                })
                .catch(() =>{
                    this.$store.dispatch('addError', {message: 'Что-то пошло не так'})
                });
            }
        },
        getUserLocations(){
            let user_string = localStorage.getItem('user');
            let user = JSON.parse(user_string);
            let findedCountry = this.getFilters.find(item => item.group === 'city');
            findedCountry ? this.getFilters.splice(this.getFilters.indexOf(findedCountry), 1) : '';
            this.getFilters.push({filter: {name: user.state, state_code: user.state_code}, group: 'city'})
        },
        async setFilter (filter, group) {
            let user = localStorage.getItem('user');
            await this.$store.dispatch('editUser', {options: {type: group, value: filter.name }, user: this.getUser.id})
                .then(() =>{
                    if (group == 'country') {
                        this.user.profile.country = filter.name
                        if (user) {
                            let new_user = JSON.parse(user);
                            new_user.country = filter.name
                            new_user.country_code = filter.country_code
                            localStorage.setItem('user', JSON.stringify(new_user))
                            // this.getUserLocations()
                        }
                    } else {
                        this.user.profile.state = filter.name
                        if (user) {
                            let new_user = JSON.parse(user);
                            new_user.state = filter.name
                            new_user.state_code = filter.state_code
                            localStorage.setItem('user', JSON.stringify(new_user))
                            // this.getUserLocations()
                        }
                    }
                })
                .catch(() =>{
                    this.$store.dispatch('addError', {message: 'Что-то пошло не так'})
                });
            await this.$store.dispatch('editUser', {options: {type: group == 'country' ? 'country_code' : 'state_code', value: group == 'country' ? filter.Iso2 : filter.state_code }, user: this.getUser.id})
                .catch(() =>{
                    this.$store.dispatch('addError', {message: 'Что-то пошло не так'})
                });
            group == 'country' ? this.states = await this.$store.dispatch('fetchCities', filter) : '';
        },
    },
    async created () {
        this.countries = [{name: 'Russia', Iso2: 'RU', Iso3: 'RUS'}]
        let new_c = await this.$store.dispatch('fetchCountries');
        this.countries = this.countries.concat(new_c)
        this.getUserCountry()
        this.states = this.country ? await this.$store.dispatch('fetchCities', this.country) : null;
        this.getUserState()
        this.sex = this.user.profile.sex
    }

}
</script>
<style lang="stylus">
    .peditor
        position fixed
        top 0
        right 0
        left 0
        bottom 0
        z-index 3
        display flex
        align-items center
        justify-content center
        
        &-container
            background-color white
            border-radius 20px
            padding 40px
            width 100%
            max-width 600px
            box-shadow 0 0 30px rgba(0,0,0,0.2)
            border 1px solid #2d2c3a
            position relative
        
            h2
                font-size 22px
                font-weight 600
        
        &-footer
            margin-top 20px
            display flex
            justify-content flex-start
        
        .modal-close
            display block

</style>